export default __webpack_public_path__ + "static/media/CapaDownload.0ff4ef06.svg";